import { createClient } from '@supabase/supabase-js';

// Types for our database tables
export interface Blog {
  id: string;
  title: string;
  slug: string;
  summary: string;
  content: string;
  cover_image: string;
  published: boolean;
  published_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface Tag {
  id: string;
  name: string;
  created_at: string;
}

export interface BlogTag {
  id: string;
  blog_id: string;
  tag_id: string;
}

export interface Portfolio {
  id: string;
  title: string;
  category: string;
  description: string;
  details: string;
  main_image: string;
  created_at: string;
  updated_at: string;
}

export interface PortfolioImage {
  id: string;
  portfolio_id: string;
  image_url: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

// Use MCP tool values directly
const supabaseUrl = "https://qivdlgmdemvqjzdhqyai.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpdmRsZ21kZW12cWp6ZGhxeWFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNjU4MTksImV4cCI6MjA2Mzk0MTgxOX0.joet2ypUEGBovYgsl801R2IWTosDq1UcV07uHwiE2r0";

export const supabase = createClient(supabaseUrl, supabaseKey);

// Helper function to check if user is authenticated
export const isAuthenticated = async (): Promise<boolean> => {
  const { data: { session } } = await supabase.auth.getSession();
  return !!session;
};

// Helper function to get current user
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}; 